import { useEffect, useState } from 'react';
import Select from 'react-select';

import Spinner from '../../../../reusable/spinner/spinner.component';
import Client from '../../../../../tools/client';

import {
  FieldSection,
  FieldGroup,
  Label,
  Toggle,
  ButtonRow,
  Button,
  Description
} from '../../configuration-sections.styles';

const client = new Client();

const CMSConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [pages, setPages] = useState([]);
  const [form, setForm] = useState({
    spaActive: false,
    landingPageActive: false,
    landingPageId: null
  });

  useEffect(() => {
    const fetchData = async () => {
      const [configRes, pagesRes] = await Promise.all([
        client.setup(),
        client.getPages()
      ]);

      const app = configRes.configuration?.app || {};
      setPages(pagesRes.rows || []);
      setForm({
        spaActive: app.spa?.active === 'true' || app.spa?.active === true,
        landingPageActive: app.landingPage?.active === 'true' || app.landingPage?.active === true,
        landingPageId: app.landingPage?.id || ''
      });

      setLoading(false);
    };

    fetchData();
  }, []);

  const handleToggle = (key) => {
    setForm({ ...form, [key]: !form[key] });
  };

  const handlePageChange = (option) => {
    setForm({ ...form, landingPageId: option?.value || '' });
  };

  const handleSave = async () => {
    const updates = {
      'spa.active': String(form.spaActive),
      'landingPage.active': String(form.landingPageActive),
      'landingPage.id': form.landingPageId
    };

    for (const [key, value] of Object.entries(updates)) {
      await client.updateConfigurationByKey(`app.${key}`, { value });
    }

    setEditing(false);
  };

  if (loading) return <Spinner />;

  const selectedPage = pages.find(p => p.id === Number(form.landingPageId));

  return (
    <FieldSection>
      <FieldGroup>
        <Label>SPA Mode</Label>
        <Description>
          Enable this if your frontend app is a Single Page Application. This allows the CMS to serve only the root HTML page and let the client-side app handle routing.
        </Description>
        <Toggle>
          <input
            type="checkbox"
            checked={form.spaActive}
            onChange={() => handleToggle('spaActive')}
            disabled={!editing}
          />
          <span />
        </Toggle>
      </FieldGroup>

      <FieldGroup>
        <Label>Landing Page Active</Label>
        <Description>
          When enabled, visitors to your root domain will be shown the selected landing page. If disabled, the homepage will default to the CMS layout.
        </Description>
        <Toggle>
          <input
            type="checkbox"
            checked={form.landingPageActive}
            onChange={() => handleToggle('landingPageActive')}
            disabled={!editing}
          />
          <span />
        </Toggle>
      </FieldGroup>

      <FieldGroup>
        <Label htmlFor="landingPageId">Landing Page</Label>
        <Description>
          Select which CMS page to use as the landing page. This will be shown if Landing Page Active is enabled.
        </Description>
        <Select
          name="landingPageId"
          value={
            selectedPage
              ? {
                  value: selectedPage.id,
                  label: selectedPage.title || `Page ${selectedPage.id}`
                }
              : null
          }
          onChange={handlePageChange}
          options={pages.map(p => ({
            value: p.id,
            label: p.title || `Page ${p.id}`
          }))}
          isDisabled={!editing}
        />
      </FieldGroup>

      <ButtonRow>
        {editing ? (
          <>
            <Button onClick={() => setEditing(false)}>Cancel</Button>
            <Button primary onClick={handleSave}>Save</Button>
          </>
        ) : (
          <Button primary onClick={() => setEditing(true)}>Edit</Button>
        )}
      </ButtonRow>
    </FieldSection>
  );
};

export default CMSConfigurationDisplay;